import React, { useState, useRef, useMemo, useEffect, useContext, useCallback } from "react";
import { Checkbox, Dropdown } from "antd";
import Loading from "@/components/Loading";
import offlineNoDataPicture from "@/assets/img/offline-noData.png";
import Item, { IProps as ItemProps } from "./Item";
import "./Main.less";
import { CheckboxValueType } from "antd/lib/checkbox/Group";
import { notUseJoySpaceOffline } from "@/components/Joyspace/util";
import { useNavigator } from "@/utils/NetworkCheck";
import events from "@/components/Joyspace/context/events";
import { ContextMenuMode } from "@/components/Joyspace/types";
const CheckboxGroup = Checkbox.Group;
interface IProps {
  list: any[];
  loading: boolean;
  hideBatchControl: Function;
  pagination?: boolean | object;
  checkedList?: string[];
  isLoadMore?: boolean;
  onButtom?: Function;
  onCheckboxChange?: (e: CheckboxValueType[]) => void;
  canDrag?: boolean;
  classNames?: string;
  isDataText?: boolean;
}
let newItem: any = {};
const Main = (props: IProps & ItemProps) => {
  const {
    list = [],
    columns,
    loading = true,
    // isCheckbox = false,
    // isDisabledListItem = false,
    isLoadMore = false,
    onButtom,
    renderActions,
    preOptions,
    afterOptions,
    handleItem,
    onCheckboxChange,
    hideBatchControl,
    contentRender,
    checkedList,
    canDrag,
    allowDraggble,
    classNames = "",
    isDataText = true
  } = props;
  const [visible, setVisible] = useState(false);
  const hideContextMenus = useCallback(() => {
    setVisible(false);
  }, []);
  useEffect(() => {
    events.on("hideContextMenus", hideContextMenus);
    return () => {
      events.off("hideContextMenus", hideContextMenus);
    };
  }, [hideContextMenus]);
  const noData = useMemo(() => {
    if (isLoadMore) {
      return (
        <p>
          数据加载失败，请
          <span
            className="nodata-reload"
            onClick={() => {
              onButtom?.();
            }}
          >
            点击重试
          </span>
        </p>
      );
    } else if (canDrag && isDataText) {
      return <p>暂无文件，拖拽文件上传或点击“新建”创建文档</p>;
    }
    return <p>暂无数据</p>;
  }, [canDrag, isLoadMore, onButtom, isDataText]);
  return (
    // <ScrollView
    //     ref={scrollViewRef}
    //     style={{ height: '100%' }}
    //     onScroll={throttle(onScroll, 400)}
    //     nohorizontal="true"
    // >
    <Dropdown
      overlayClassName={`joyspace-context-menus ${classNames}`}
      visible={visible}
      overlay={() => {
        return renderActions?.(newItem, ContextMenuMode.ContextMenu) || <span />;
      }}
      trigger={["contextMenu"]}
    >
      <div
        className="main-list"
        data-menu="contextMenu"
        onContextMenu={(event) => {
          // 防止点击空白区域
          if (!useNavigator.onLine || !list.length) {
            return;
          }
          events.emit("hideContextMenus");
          if (event?.target) {
            const attr = (event.target as any).getAttribute("data-menu");
            if (attr === "contextMenu") {
              return;
            }
          }
          hideBatchControl();
          setVisible(true);
        }}
      >
        <CheckboxGroup
          value={checkedList || []}
          onChange={(e: CheckboxValueType[]) => {
            onCheckboxChange?.(e);
          }}
        >
          {!loading &&
            list.length > 0 &&
            list.map((item: any, index: number) => {
              delete item.isChecked; // 修复 http://jagile.jd.com/test-manage/jbug/1190976 这个bug
              return (
                <Item
                  onContextMenu={() => {
                    newItem = item;
                  }}
                  allowDraggble={allowDraggble}
                  renderActions={renderActions}
                  preOptions={preOptions}
                  afterOptions={afterOptions}
                  // isDisabledListItem={isDisabledListItem}
                  handleItem={handleItem}
                  // isCheckbox={isCheckbox}
                  contentRender={contentRender}
                  columns={columns}
                  key={item.id || index}
                  isChecked={
                    // (visible && item.id === newItem.id) ||
                    checkedList?.some((id) => item.id === id)
                  }
                  item={item}
                />
              );
            })}
        </CheckboxGroup>
        {loading && !list.length && (
          <div className="joyspace-list-table-not-data">
            <div className="list-table-loading">
              <Loading />
            </div>
          </div>
        )}
        {isLoadMore && list.length > 0 && (
          <div className="joyspace-list-table-not-data">
            <div className="joyspace-list-more">
              <span
                style={{ whiteSpace: "nowrap" }}
                onClick={() => {
                  onButtom?.();
                }}
              >
                加载更多
              </span>
            </div>
          </div>
        )}
        {!loading && !list.length && (
          <div className="joyspace-list-table-not-data">
            {notUseJoySpaceOffline() || useNavigator.onLine ? (
              <div className="pm-doc-nodata">
                <img src={offlineNoDataPicture} />
                {noData}
              </div>
            ) : (
              <div className="pm-doc-nodata">
                <img src={offlineNoDataPicture} />
                <p>暂无缓存信息，请联网后查看</p>
              </div>
            )}
          </div>
        )}
      </div>
    </Dropdown>
    // </ScrollView>
  );
};

export default Main;
